import React, { useState } from 'react';
import { Modal } from 'reactstrap';

const WarningDialog = () => {
  const [isOpen, setIsOpen] = useState(true);
  return (
    <Modal centered isOpen={isOpen}>
      <div className='modal-image-section'>
        <img src='/images/popup.jpg' alt='warning' className='img1' />
        <img
          src='/images/close.png'
          alt='close'
          className='img2'
          onClick={() => setIsOpen((prev) => !prev)}
        />
      </div>
    </Modal>
  );
};

export default WarningDialog;
